// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Select {
  cursor: pointer;
  height: 40px;
  margin-bottom: 16px;
  width: 100%;
  color: white;
  font-family: "Montserrat Regular";
  font-weight: 500;
  font-size: 12px;
}

.BodyTextOne {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/components/Select/Select.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,YAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,iCAAA;EACA,gBAAA;EACA,eAAA;AACF;;AACA;EACE,eAAA;AAEF","sourcesContent":[".Select {\r\n  cursor: pointer;\r\n  height: 40px;\r\n  margin-bottom: 16px;\r\n  width: 100%;\r\n  color: #ffff;\r\n  font-family: 'Montserrat Regular';\r\n  font-weight: 500; \r\n  font-size: 12px;\r\n}\r\n.BodyTextOne{\r\n  cursor: pointer;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Select": `Select`,
	"BodyTextOne": `BodyTextOne`
};
export default ___CSS_LOADER_EXPORT___;
